import React, { useEffect, useState } from "react";
import { listBankDetails, deleteBankDetail, withBase } from "./api";
import styles from "./List.module.css";

export default function BankDetailsList() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  const [busyId, setBusyId] = useState(null);

  useEffect(() => {
    listBankDetails()
      .then((res) => setItems(res.items || []))
      .catch((e) => setError(e.message || "Failed to load bank details"));
  }, []);

  return (
    <div className={styles.card}>
      <div className={styles.headerRow}>
        <div className={styles.title}>Bank Details</div>
        <div>
          <button
            className={`${styles.btn} ${styles.btnEdit}`}
            type="button"
            onClick={() => {
              window.location.href = "/admin/bank-details/add";
            }}
          >
            Add Bank Details
          </button>
        </div>
      </div>

      {error && <div className={styles.empty}>{error}</div>}
      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead className={styles.thead}>
            <tr>
              <th className={styles.th}>#</th>
              <th className={styles.th}>Account Name</th>
              <th className={styles.th}>Account Number</th>
              <th className={styles.th}>IFSC</th>
              <th className={styles.th}>Bank</th>
              <th className={styles.th}>Branch</th>
              <th className={styles.th}>UPI ID</th>
              <th className={styles.th}>Status</th>
              <th className={styles.th}>QR Code</th>
              <th className={styles.th}>Action</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr>
                <td className={styles.empty} colSpan={10}>No bank details found.</td>
              </tr>
            ) : (
              items.map((item, idx) => (
                <tr key={item.id}>
                  <td className={styles.td}>{idx + 1}</td>
                  <td className={styles.td}>{item.account_name}</td>
                  <td className={styles.td}>{item.account_number}</td>
                  <td className={styles.td}>{item.ifsc_code}</td>
                  <td className={styles.td}>{item.bank_name}</td>
                  <td className={styles.td}>{item.branch_name}</td>
                  <td className={styles.td}>{item.upi_id}</td>
                  <td className={styles.td}>
                    <span style={{
                      display: 'inline-block',
                      padding: '4px 12px',
                      borderRadius: '999px',
                      backgroundColor: item.status === 'Active' ? '#16a34a' : '#6b7280',
                      color: '#fff',
                      fontSize: '0.85rem',
                      fontWeight: 700,
                    }}>
                      {item.status}
                    </span>
                  </td>
                  <td className={styles.td}>
                    {item.qr_code_path ? (
                      <div style={{ width: 80, height: 80, overflow: 'hidden', borderRadius: 10, border: '1px solid #e5e7eb' }}>
                        <img src={withBase(item.qr_code_path)} alt="QR code" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      </div>
                    ) : (
                      <span style={{ color: '#9ca3af' }}>No QR</span>
                    )}
                  </td>
                  <td className={styles.td}>
                    <div className={styles.actions}>
                      <button
                        className={`${styles.btn} ${styles.btnEdit}`}
                        type="button"
                        onClick={() => {
                          const params = new URLSearchParams({ id: String(item.id) });
                          window.location.href = `/admin/bank-details/add?${params.toString()}`;
                        }}
                      >
                        Edit
                      </button>
                      <button
                        className={`${styles.btn} ${styles.btnDelete}`}
                        type="button"
                        disabled={busyId === item.id}
                        onClick={async () => {
                          if (!window.confirm('Delete this record?')) return;
                          setBusyId(item.id);
                          try {
                            await deleteBankDetail(item.id);
                            setItems(items.filter((row) => row.id !== item.id));
                          } catch (error) {
                            setError(error.message || 'Delete failed');
                          } finally {
                            setBusyId(null);
                          }
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
